import {
  IncompleteLocalDate2wlnrm8wqbjky as IncompleteLocalDate,
  get_ISO_DATE1ah0stqy13618 as get_ISO_DATE,
  Companion_getInstance2euvj2567gjrn as Companion_getInstance,
  Companion_getInstanceem9vodzsunmv as Companion_getInstance_0,
  requireParsedField387b2jr94jy2p as requireParsedField,
  year2o42o5s31g3p8 as year,
  monthNumber39ajqip9c32rn as monthNumber,
  monthNames1ujl7xt4e7x as monthName,
  dayOfMonths8rfgqv9djoz as dayOfMonth,
  dayOfWeek16trujebvwhwq as dayOfWeek,
  date3ki45iw426xr8 as date,
} from './LocalDateFormat.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  IncompleteLocalTime3h4nusjwtlckd as IncompleteLocalTime,
  TimeFieldContainer3bsvpq7sk70go as TimeFieldContainer,
  hour31jxjrzfyqe0i as hour,
  amPmHour1hvi7u14xj951 as amPmHour,
  amPmMarker15xvjzra6ar5a as amPmMarker,
  minute2dqmds23fogn6 as minute,
  secondq4lhw2ppe1iv as second,
  secondFraction17r4cie9ncxw as secondFraction,
  time3kvfctmdykstm as time,
} from './LocalTimeFormat.mjs';
import {
  IncompleteUtcOffset2j7l7xiralfth as IncompleteUtcOffset,
  UtcOffsetFieldContainer34kiua261u8tn as UtcOffsetFieldContainer,
  offsetHours2ainakfaneygi as offsetHours,
  offsetMinutesOfHour39hwa562rk4r3 as offsetMinutesOfHour,
  offsetSecondsOfMinute2h4jaqdr0ywca as offsetSecondsOfMinute,
  offset2sn0i35letyt2 as offset,
  AbstractWithOffsetBuilder1whsl6o4h46l as AbstractWithOffsetBuilder,
} from './UtcOffsetFormat.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  alternativeParsing1gmwubnsvpp9b as alternativeParsing,
  char1r4ssccmdfesy as char,
  optional3j6ywsx1pxeh6 as optional,
  appendAlternativeParsingImpl1mug8j87kp2j3 as appendAlternativeParsingImpl,
  appendOptionalImplcg29ds00y54b as appendOptionalImpl,
  chars1g48a4lypizqb as chars,
  build284bs2tzkjm2x as build,
  year$defaulto1ef087ubfdc as year$default,
  monthNumber$default3k7qk403bnffp as monthNumber$default,
  dayOfMonth$default2fd2gjqoxzh9x as dayOfMonth$default,
  hour$default28zjolx0s9fg0 as hour$default,
  minute$defaultoouhhkuji8pa as minute$default,
  second$default25cj8g9tgx4nm as second$default,
  offsetHours$default2ltn8vk6i6a0z as offsetHours$default,
  offsetMinutesOfHour$defaultx23z50nh5v5p as offsetMinutesOfHour$default,
  offsetSecondsOfMinute$defaultxai9ucsyqlc7 as offsetSecondsOfMinute$default,
  AbstractDateTimeFormatBuilder2kkelk07l4wb as AbstractDateTimeFormatBuilder,
  WithDate2bqihss8t5xfv as WithDate,
  WithTime2lgb7k6hqa1zi as WithTime,
  WithUtcOffset30ws1ntcash0j as WithUtcOffset,
} from './DateTimeFormatBuilder.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Formats_instance4hly74zje37n as Formats_instance } from '../UtcOffset.mjs';
import {
  Padding_NONE_getInstance3nt67hl4ceygz as Padding_NONE_getInstance,
  AbstractDateTimeFormat1er9ki1vjeb1b as AbstractDateTimeFormat,
} from './DateTimeFormat.mjs';
import { AppendableFormatStructure38mt32f1b8qva as AppendableFormatStructure } from '../internal/format/Builder.mjs';
import {
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
} from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  multiply2k9eolhnz1bjv as multiply,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  safeMultiply1xb0xo3cufzd3 as safeMultiply,
  safeAdd2ojtf0puot5k0 as safeAdd,
} from '../internal/mathJs.mjs';
import { DateTimeFormatException2onfeknbywaob as DateTimeFormatException } from '../Exceptions.mjs';
import { ArithmeticException18dajwq7kbp38 as ArithmeticException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Companion_getInstance3vjikuur3h0k4 as Companion_getInstance_1 } from '../Instant.mjs';
import {
  addFormatStructureForDate3d5amh7zu2xvd as addFormatStructureForDate,
  addFormatStructureForTime1tqep05b2dvut as addFormatStructureForTime,
  AbstractWithDateTimeBuilder2fkc9fus0fd8o as AbstractWithDateTimeBuilder,
} from './LocalDateTimeFormat.mjs';
import {
  PropertyAccessor1m9zk65ebkfc4 as PropertyAccessor,
  GenericFieldSpecnllvuuqbuxsd as GenericFieldSpec,
} from '../internal/format/FieldSpec.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var timeZoneField;
function get_emptyDateTimeComponentsContents() {
  _init_properties_DateTimeComponents_kt__9iimb5();
  return emptyDateTimeComponentsContents;
}
var emptyDateTimeComponentsContents;
var DateTimeComponentsContentsClass;
function DateTimeComponentsContents() {
  if (DateTimeComponentsContentsClass === VOID) {
    class $ {
      constructor(date, time, offset, timeZoneId) {
        date = date === VOID ? new (IncompleteLocalDate())() : date;
        time = time === VOID ? new (IncompleteLocalTime())() : time;
        offset = offset === VOID ? new (IncompleteUtcOffset())() : offset;
        timeZoneId = timeZoneId === VOID ? null : timeZoneId;
        this.g1p_1 = date;
        this.h1p_1 = time;
        this.i1p_1 = offset;
        this.j1p_1 = timeZoneId;
      }
      k1p(_set____db54di) {
        this.g1p_1.n1p_1 = _set____db54di;
      }
      t1o() {
        return this.g1p_1.n1p_1;
      }
      p1p(_set____db54di) {
        this.g1p_1.o1p_1 = _set____db54di;
      }
      q1p() {
        return this.g1p_1.o1p_1;
      }
      r1p(_set____db54di) {
        this.g1p_1.m1p_1 = _set____db54di;
      }
      s1o() {
        return this.g1p_1.m1p_1;
      }
      s1p(_set____db54di) {
        this.g1p_1.l1p_1 = _set____db54di;
      }
      r1o() {
        return this.g1p_1.l1p_1;
      }
      t1p(_set____db54di) {
        this.h1p_1.w1p_1 = _set____db54di;
      }
      a1q() {
        return this.h1p_1.w1p_1;
      }
      b1q(value) {
        this.h1p_1.b1q(value);
      }
      c1q() {
        return this.h1p_1.c1q();
      }
      d1q(_set____db54di) {
        this.h1p_1.u1p_1 = _set____db54di;
      }
      z1o() {
        return this.h1p_1.u1p_1;
      }
      e1q(_set____db54di) {
        this.h1p_1.v1p_1 = _set____db54di;
      }
      f1q() {
        return this.h1p_1.v1p_1;
      }
      g1q(_set____db54di) {
        this.h1p_1.x1p_1 = _set____db54di;
      }
      a1p() {
        return this.h1p_1.x1p_1;
      }
      h1q(_set____db54di) {
        this.h1p_1.z1p_1 = _set____db54di;
      }
      c1p() {
        return this.h1p_1.z1p_1;
      }
      i1q(_set____db54di) {
        this.h1p_1.y1p_1 = _set____db54di;
      }
      b1p() {
        return this.h1p_1.y1p_1;
      }
      j1q(_set____db54di) {
        this.i1p_1.k1q_1 = _set____db54di;
      }
      o1q() {
        return this.i1p_1.k1q_1;
      }
      p1q(_set____db54di) {
        this.i1p_1.m1q_1 = _set____db54di;
      }
      q1q() {
        return this.i1p_1.m1q_1;
      }
      r1q(_set____db54di) {
        this.i1p_1.n1q_1 = _set____db54di;
      }
      s1q() {
        return this.i1p_1.n1q_1;
      }
      t1q(_set____db54di) {
        this.i1p_1.l1q_1 = _set____db54di;
      }
      u1q() {
        return this.i1p_1.l1q_1;
      }
      v1q() {
        return new (DateTimeComponentsContents())(this.g1p_1.v1q(), this.h1p_1.v1q(), this.i1p_1.v1q(), this.j1p_1);
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        var tmp_2;
        if (other instanceof DateTimeComponentsContents()) {
          tmp_2 = other.g1p_1.equals(this.g1p_1);
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp_1 = other.h1p_1.equals(this.h1p_1);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = other.i1p_1.equals(this.i1p_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = other.j1p_1 == this.j1p_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        var tmp = this.g1p_1.hashCode() ^ this.h1p_1.hashCode() ^ this.i1p_1.hashCode();
        var tmp0_safe_receiver = this.j1p_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
        return tmp ^ (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs);
      }
    }
    initMetadataForClass($, 'DateTimeComponentsContents', VOID, VOID, [TimeFieldContainer(), UtcOffsetFieldContainer()]);
    DateTimeComponentsContentsClass = $;
  }
  return DateTimeComponentsContentsClass;
}
function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda($this$Format) {
  $this$Format.w1q(get_ISO_DATE());
  var tmp = [DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda];
  alternativeParsing($this$Format, tmp, DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_0);
  $this$Format.x1q();
  char($this$Format, _Char___init__impl__6a9atx(58));
  $this$Format.y1q();
  char($this$Format, _Char___init__impl__6a9atx(58));
  $this$Format.z1q();
  optional($this$Format, VOID, DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_1);
  var tmp_0 = [DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_2];
  alternativeParsing($this$Format, tmp_0, DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_3);
  return Unit_instance;
}
function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda($this$alternativeParsing) {
  char($this$alternativeParsing, _Char___init__impl__6a9atx(116));
  return Unit_instance;
}
function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_0($this$alternativeParsing) {
  char($this$alternativeParsing, _Char___init__impl__6a9atx(84));
  return Unit_instance;
}
function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_1($this$optional) {
  char($this$optional, _Char___init__impl__6a9atx(46));
  $this$optional.a1r(1, 9);
  return Unit_instance;
}
function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_2($this$alternativeParsing) {
  $this$alternativeParsing.b1r();
  return Unit_instance;
}
function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_3($this$alternativeParsing) {
  $this$alternativeParsing.c1r(Formats_instance.p1o());
  return Unit_instance;
}
function DateTimeComponents$Formats$RFC_1123$lambda($this$Format) {
  var tmp = [DateTimeComponents$Formats$RFC_1123$lambda$lambda];
  alternativeParsing($this$Format, tmp, DateTimeComponents$Formats$RFC_1123$lambda$lambda_0);
  $this$Format.d1r(Padding_NONE_getInstance());
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.g1r(Companion_getInstance().f1r_1);
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.h1r();
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.x1q();
  char($this$Format, _Char___init__impl__6a9atx(58));
  $this$Format.y1q();
  optional($this$Format, VOID, DateTimeComponents$Formats$RFC_1123$lambda$lambda_1);
  $this$Format.i1r(' ');
  var tmp_0 = DateTimeComponents$Formats$RFC_1123$lambda$lambda_2;
  var tmp_1 = [tmp_0, DateTimeComponents$Formats$RFC_1123$lambda$lambda_3];
  alternativeParsing($this$Format, tmp_1, DateTimeComponents$Formats$RFC_1123$lambda$lambda_4);
  return Unit_instance;
}
function DateTimeComponents$Formats$RFC_1123$lambda$lambda($this$alternativeParsing) {
  return Unit_instance;
}
function DateTimeComponents$Formats$RFC_1123$lambda$lambda_0($this$alternativeParsing) {
  $this$alternativeParsing.l1r(Companion_getInstance_0().k1r_1);
  $this$alternativeParsing.i1r(', ');
  return Unit_instance;
}
function DateTimeComponents$Formats$RFC_1123$lambda$lambda_1($this$optional) {
  char($this$optional, _Char___init__impl__6a9atx(58));
  $this$optional.z1q();
  return Unit_instance;
}
function DateTimeComponents$Formats$RFC_1123$lambda$lambda_2($this$alternativeParsing) {
  $this$alternativeParsing.i1r('UT');
  return Unit_instance;
}
function DateTimeComponents$Formats$RFC_1123$lambda$lambda_3($this$alternativeParsing) {
  $this$alternativeParsing.i1r('Z');
  return Unit_instance;
}
function DateTimeComponents$Formats$RFC_1123$lambda$lambda_4($this$alternativeParsing) {
  optional($this$alternativeParsing, 'GMT', DateTimeComponents$Formats$RFC_1123$lambda$lambda$lambda);
  return Unit_instance;
}
function DateTimeComponents$Formats$RFC_1123$lambda$lambda$lambda($this$optional) {
  $this$optional.c1r(Formats_instance.m1r());
  return Unit_instance;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      n1r(block) {
        var builder = new (Builder())(new (AppendableFormatStructure())());
        block(builder);
        return new (DateTimeComponentsFormat())(builder.o1r());
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_2() {
  return Companion_instance;
}
var FormatsClass;
function Formats() {
  if (FormatsClass === VOID) {
    class $ {
      constructor() {
        Formats_instance_0 = this;
        var tmp = this;
        var tmp_0 = Companion_instance;
        tmp.p1r_1 = tmp_0.n1r(DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda);
        var tmp_1 = this;
        var tmp_2 = Companion_instance;
        tmp_1.q1r_1 = tmp_2.n1r(DateTimeComponents$Formats$RFC_1123$lambda);
      }
    }
    initMetadataForObject($, 'Formats');
    FormatsClass = $;
  }
  return FormatsClass;
}
var Formats_instance_0;
function Formats_getInstance() {
  if (Formats_instance_0 === VOID)
    new (Formats())();
  return Formats_instance_0;
}
function IncompleteLocalDate$_get_year_$ref_daef0a(p0) {
  return () => p0.l1p_1;
}
function IncompleteLocalDate$_set_year_$ref_hi3ji(p0) {
  return (_this__u8e3s4) => {
    p0.l1p_1 = _this__u8e3s4;
    return Unit_instance;
  };
}
function DateTimeComponents$_get_year_$ref_8jgxao() {
  return (p0) => p0.r1o();
}
function DateTimeComponents$_set_year_$ref_49fe64() {
  return (p0, p1) => {
    p0.s1p(p1);
    return Unit_instance;
  };
}
function DateTimeComponents$_get_year_$ref_8jgxao_0() {
  return (p0) => p0.r1o();
}
function DateTimeComponents$_set_year_$ref_49fe64_0() {
  return (p0, p1) => {
    p0.s1p(p1);
    return Unit_instance;
  };
}
function IncompleteLocalDate$_get_monthNumber_$ref_ba4wq6(p0) {
  return () => p0.m1p_1;
}
function IncompleteLocalDate$_set_monthNumber_$ref_16ep7m(p0) {
  return (_this__u8e3s4) => {
    p0.m1p_1 = _this__u8e3s4;
    return Unit_instance;
  };
}
function IncompleteLocalDate$_get_dayOfMonth_$ref_31uaae(p0) {
  return () => p0.n1p_1;
}
function IncompleteLocalDate$_set_dayOfMonth_$ref_mh95r2(p0) {
  return (_this__u8e3s4) => {
    p0.n1p_1 = _this__u8e3s4;
    return Unit_instance;
  };
}
function IncompleteLocalTime$_get_hour_$ref_3ms3pc(p0) {
  return () => p0.u1p_1;
}
function IncompleteLocalTime$_set_hour_$ref_9647rg(p0) {
  return (_this__u8e3s4) => {
    p0.u1p_1 = _this__u8e3s4;
    return Unit_instance;
  };
}
function IncompleteLocalTime$_get_hourOfAmPm_$ref_iccr34(p0) {
  return () => p0.v1p_1;
}
function IncompleteLocalTime$_set_hourOfAmPm_$ref_76qoyc(p0) {
  return (_this__u8e3s4) => {
    p0.v1p_1 = _this__u8e3s4;
    return Unit_instance;
  };
}
function IncompleteLocalTime$_get_amPm_$ref_spitbv(p0) {
  return () => p0.w1p_1;
}
function IncompleteLocalTime$_set_amPm_$ref_tiox6h(p0) {
  return (_this__u8e3s4) => {
    p0.w1p_1 = _this__u8e3s4;
    return Unit_instance;
  };
}
function IncompleteLocalTime$_get_minute_$ref_fv9tbk(p0) {
  return () => p0.x1p_1;
}
function IncompleteLocalTime$_set_minute_$ref_t186c(p0) {
  return (_this__u8e3s4) => {
    p0.x1p_1 = _this__u8e3s4;
    return Unit_instance;
  };
}
function IncompleteLocalTime$_get_second_$ref_s7ut4g(p0) {
  return () => p0.y1p_1;
}
function IncompleteLocalTime$_set_second_$ref_rr0npg(p0) {
  return (_this__u8e3s4) => {
    p0.y1p_1 = _this__u8e3s4;
    return Unit_instance;
  };
}
function IncompleteUtcOffset$_get_isNegative_$ref_g6l9sq(p0) {
  return () => p0.k1q_1;
}
function IncompleteUtcOffset$_set_isNegative_$ref_tbfc4y(p0) {
  return (_this__u8e3s4) => {
    p0.k1q_1 = _this__u8e3s4;
    return Unit_instance;
  };
}
function IncompleteUtcOffset$_get_totalHoursAbs_$ref_eda9m6(p0) {
  return () => p0.l1q_1;
}
function IncompleteUtcOffset$_set_totalHoursAbs_$ref_yy0w2m(p0) {
  return (_this__u8e3s4) => {
    p0.l1q_1 = _this__u8e3s4;
    return Unit_instance;
  };
}
function IncompleteUtcOffset$_get_minutesOfHour_$ref_9iuh1(p0) {
  return () => p0.m1q_1;
}
function IncompleteUtcOffset$_set_minutesOfHour_$ref_lga1tb(p0) {
  return (_this__u8e3s4) => {
    p0.m1q_1 = _this__u8e3s4;
    return Unit_instance;
  };
}
function IncompleteUtcOffset$_get_secondsOfMinute_$ref_tb0105(p0) {
  return () => p0.n1q_1;
}
function IncompleteUtcOffset$_set_secondsOfMinute_$ref_sfds2n(p0) {
  return (_this__u8e3s4) => {
    p0.n1q_1 = _this__u8e3s4;
    return Unit_instance;
  };
}
function DateTimeComponentsContents$_get_timeZoneId_$ref_e986wv(p0) {
  return () => p0.j1p_1;
}
function DateTimeComponentsContents$_set_timeZoneId_$ref_b9v94l(p0) {
  return (_this__u8e3s4) => {
    p0.j1p_1 = _this__u8e3s4;
    return Unit_instance;
  };
}
var DateTimeComponentsClass;
function DateTimeComponents() {
  if (DateTimeComponentsClass === VOID) {
    class $ {
      constructor(contents) {
        contents = contents === VOID ? new (DateTimeComponentsContents())() : contents;
        this.r1r_1 = contents;
        var tmp = this;
        var tmp0 = this.r1r_1.g1p_1;
        var tmp_0 = KMutableProperty0();
        var tmp_1 = IncompleteLocalDate$_get_year_$ref_daef0a(tmp0);
        tmp.s1r_1 = getPropertyCallableRef('year', 0, tmp_0, tmp_1, IncompleteLocalDate$_set_year_$ref_hi3ji(tmp0));
        var tmp_2 = this;
        var tmp0_0 = this.r1r_1.g1p_1;
        var tmp_3 = KMutableProperty0();
        var tmp_4 = IncompleteLocalDate$_get_monthNumber_$ref_ba4wq6(tmp0_0);
        tmp_2.t1r_1 = new (TwoDigitNumber())(getPropertyCallableRef('monthNumber', 0, tmp_3, tmp_4, IncompleteLocalDate$_set_monthNumber_$ref_16ep7m(tmp0_0)));
        var tmp_5 = this;
        var tmp0_1 = this.r1r_1.g1p_1;
        var tmp_6 = KMutableProperty0();
        var tmp_7 = IncompleteLocalDate$_get_dayOfMonth_$ref_31uaae(tmp0_1);
        tmp_5.u1r_1 = new (TwoDigitNumber())(getPropertyCallableRef('dayOfMonth', 0, tmp_6, tmp_7, IncompleteLocalDate$_set_dayOfMonth_$ref_mh95r2(tmp0_1)));
        var tmp_8 = this;
        var tmp0_2 = this.r1r_1.h1p_1;
        var tmp_9 = KMutableProperty0();
        var tmp_10 = IncompleteLocalTime$_get_hour_$ref_3ms3pc(tmp0_2);
        tmp_8.v1r_1 = new (TwoDigitNumber())(getPropertyCallableRef('hour', 0, tmp_9, tmp_10, IncompleteLocalTime$_set_hour_$ref_9647rg(tmp0_2)));
        var tmp_11 = this;
        var tmp0_3 = this.r1r_1.h1p_1;
        var tmp_12 = KMutableProperty0();
        var tmp_13 = IncompleteLocalTime$_get_hourOfAmPm_$ref_iccr34(tmp0_3);
        tmp_11.w1r_1 = new (TwoDigitNumber())(getPropertyCallableRef('hourOfAmPm', 0, tmp_12, tmp_13, IncompleteLocalTime$_set_hourOfAmPm_$ref_76qoyc(tmp0_3)));
        var tmp_14 = this;
        var tmp0_4 = this.r1r_1.h1p_1;
        var tmp_15 = KMutableProperty0();
        var tmp_16 = IncompleteLocalTime$_get_amPm_$ref_spitbv(tmp0_4);
        tmp_14.x1r_1 = getPropertyCallableRef('amPm', 0, tmp_15, tmp_16, IncompleteLocalTime$_set_amPm_$ref_tiox6h(tmp0_4));
        var tmp_17 = this;
        var tmp0_5 = this.r1r_1.h1p_1;
        var tmp_18 = KMutableProperty0();
        var tmp_19 = IncompleteLocalTime$_get_minute_$ref_fv9tbk(tmp0_5);
        tmp_17.y1r_1 = new (TwoDigitNumber())(getPropertyCallableRef('minute', 0, tmp_18, tmp_19, IncompleteLocalTime$_set_minute_$ref_t186c(tmp0_5)));
        var tmp_20 = this;
        var tmp0_6 = this.r1r_1.h1p_1;
        var tmp_21 = KMutableProperty0();
        var tmp_22 = IncompleteLocalTime$_get_second_$ref_s7ut4g(tmp0_6);
        tmp_20.z1r_1 = new (TwoDigitNumber())(getPropertyCallableRef('second', 0, tmp_21, tmp_22, IncompleteLocalTime$_set_second_$ref_rr0npg(tmp0_6)));
        var tmp_23 = this;
        var tmp0_7 = this.r1r_1.i1p_1;
        var tmp_24 = KMutableProperty0();
        var tmp_25 = IncompleteUtcOffset$_get_isNegative_$ref_g6l9sq(tmp0_7);
        tmp_23.a1s_1 = getPropertyCallableRef('isNegative', 0, tmp_24, tmp_25, IncompleteUtcOffset$_set_isNegative_$ref_tbfc4y(tmp0_7));
        var tmp_26 = this;
        var tmp0_8 = this.r1r_1.i1p_1;
        var tmp_27 = KMutableProperty0();
        var tmp_28 = IncompleteUtcOffset$_get_totalHoursAbs_$ref_eda9m6(tmp0_8);
        tmp_26.b1s_1 = new (TwoDigitNumber())(getPropertyCallableRef('totalHoursAbs', 0, tmp_27, tmp_28, IncompleteUtcOffset$_set_totalHoursAbs_$ref_yy0w2m(tmp0_8)));
        var tmp_29 = this;
        var tmp0_9 = this.r1r_1.i1p_1;
        var tmp_30 = KMutableProperty0();
        var tmp_31 = IncompleteUtcOffset$_get_minutesOfHour_$ref_9iuh1(tmp0_9);
        tmp_29.c1s_1 = new (TwoDigitNumber())(getPropertyCallableRef('minutesOfHour', 0, tmp_30, tmp_31, IncompleteUtcOffset$_set_minutesOfHour_$ref_lga1tb(tmp0_9)));
        var tmp_32 = this;
        var tmp0_10 = this.r1r_1.i1p_1;
        var tmp_33 = KMutableProperty0();
        var tmp_34 = IncompleteUtcOffset$_get_secondsOfMinute_$ref_tb0105(tmp0_10);
        tmp_32.d1s_1 = new (TwoDigitNumber())(getPropertyCallableRef('secondsOfMinute', 0, tmp_33, tmp_34, IncompleteUtcOffset$_set_secondsOfMinute_$ref_sfds2n(tmp0_10)));
        var tmp_35 = this;
        var tmp0_11 = this.r1r_1;
        var tmp_36 = KMutableProperty0();
        var tmp_37 = DateTimeComponentsContents$_get_timeZoneId_$ref_e986wv(tmp0_11);
        tmp_35.e1s_1 = getPropertyCallableRef('timeZoneId', 0, tmp_36, tmp_37, DateTimeComponentsContents$_set_timeZoneId_$ref_b9v94l(tmp0_11));
      }
      s1p(_set____db54di) {
        var tmp0 = this.s1r_1;
        var tmp = KMutableProperty1();
        var tmp_0 = DateTimeComponents$_get_year_$ref_8jgxao_0();
        // Inline function 'kotlin.setValue' call
        getPropertyCallableRef('year', 1, tmp, tmp_0, DateTimeComponents$_set_year_$ref_49fe64_0());
        tmp0.set(_set____db54di);
        return Unit_instance;
      }
      r1o() {
        var tmp0 = this.s1r_1;
        var tmp = KMutableProperty1();
        var tmp_0 = DateTimeComponents$_get_year_$ref_8jgxao();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('year', 1, tmp, tmp_0, DateTimeComponents$_set_year_$ref_49fe64());
        return tmp0.get();
      }
      c1p() {
        return this.r1r_1.h1p_1.z1p_1;
      }
      f1s() {
        return this.r1r_1.i1p_1.f1s();
      }
      g1s() {
        return this.r1r_1.h1p_1.g1s();
      }
      h1s() {
        var offset = this.f1s();
        var time = this.g1s();
        var truncatedDate = this.r1r_1.g1p_1.v1q();
        truncatedDate.l1p_1 = requireParsedField(truncatedDate.l1p_1, 'year') % 10000 | 0;
        var tmp;
        try {
          var secDelta = safeMultiply(fromInt(ensureNotNull(this.r1o()) / 10000 | 0), 315569520000n);
          var epochDays = fromInt(truncatedDate.i1s().j1s());
          // Inline function 'kotlin.Long.times' call
          var tmp0 = multiply(epochDays, fromInt(86400));
          // Inline function 'kotlin.Long.plus' call
          var other = time.k1s();
          var tmp0_0 = add(tmp0, fromInt(other));
          // Inline function 'kotlin.Long.minus' call
          var other_0 = offset.m1s();
          var tmp$ret$2 = subtract(tmp0_0, fromInt(other_0));
          tmp = safeAdd(secDelta, tmp$ret$2);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof ArithmeticException()) {
            var e = $p;
            throw DateTimeFormatException().b1o('The parsed date is outside the range representable by Instant', e);
          } else {
            throw $p;
          }
        }
        var totalSeconds = tmp;
        if (totalSeconds < Companion_getInstance_1().g1m_1.o1s() || totalSeconds > Companion_getInstance_1().h1m_1.o1s())
          throw DateTimeFormatException().a1n('The parsed date is outside the range representable by Instant');
        var tmp_1 = Companion_getInstance_1();
        var tmp0_elvis_lhs = this.c1p();
        return tmp_1.dv(totalSeconds, tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs);
      }
    }
    initMetadataForClass($, 'DateTimeComponents');
    DateTimeComponentsClass = $;
  }
  return DateTimeComponentsClass;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(actualBuilder) {
        this.p1s_1 = actualBuilder;
      }
      q1s() {
        return this.p1s_1;
      }
      r1s(structure) {
        this.p1s_1.t1s(structure);
      }
      u1s(structure) {
        this.p1s_1.t1s(structure);
      }
      v1s() {
        return new (Builder())(new (AppendableFormatStructure())());
      }
    }
    protoOf($).w1s = appendAlternativeParsingImpl;
    protoOf($).x1s = appendOptionalImpl;
    protoOf($).i1r = chars;
    protoOf($).o1r = build;
    protoOf($).y1s = addFormatStructureForDate;
    protoOf($).z1s = addFormatStructureForTime;
    protoOf($).a1t = year;
    protoOf($).h1r = year$default;
    protoOf($).b1t = monthNumber;
    protoOf($).c1t = monthNumber$default;
    protoOf($).g1r = monthName;
    protoOf($).d1r = dayOfMonth;
    protoOf($).d1t = dayOfMonth$default;
    protoOf($).l1r = dayOfWeek;
    protoOf($).w1q = date;
    protoOf($).e1t = hour;
    protoOf($).x1q = hour$default;
    protoOf($).f1t = amPmHour;
    protoOf($).g1t = amPmMarker;
    protoOf($).h1t = minute;
    protoOf($).y1q = minute$default;
    protoOf($).i1t = second;
    protoOf($).z1q = second$default;
    protoOf($).a1r = secondFraction;
    protoOf($).j1t = time;
    protoOf($).k1t = offsetHours;
    protoOf($).b1r = offsetHours$default;
    protoOf($).l1t = offsetMinutesOfHour;
    protoOf($).m1t = offsetMinutesOfHour$default;
    protoOf($).n1t = offsetSecondsOfMinute;
    protoOf($).o1t = offsetSecondsOfMinute$default;
    protoOf($).c1r = offset;
    initMetadataForClass($, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder(), AbstractWithDateTimeBuilder(), AbstractWithOffsetBuilder(), WithDate(), WithTime(), WithUtcOffset()]);
    BuilderClass = $;
  }
  return BuilderClass;
}
var DateTimeComponentsFormatClass;
function DateTimeComponentsFormat() {
  if (DateTimeComponentsFormatClass === VOID) {
    class $ extends AbstractDateTimeFormat() {
      constructor(actualFormat) {
        super();
        this.p1t_1 = actualFormat;
      }
      q1t() {
        return this.p1t_1;
      }
      r1t(value) {
        return value.r1r_1;
      }
      s1t(value) {
        return this.r1t(value instanceof DateTimeComponents() ? value : THROW_CCE());
      }
      t1t(intermediate) {
        return new (DateTimeComponents())(intermediate);
      }
      u1t(intermediate) {
        return this.t1t(intermediate instanceof DateTimeComponentsContents() ? intermediate : THROW_CCE());
      }
      v1t() {
        return get_emptyDateTimeComponentsContents();
      }
    }
    initMetadataForClass($, 'DateTimeComponentsFormat');
    DateTimeComponentsFormatClass = $;
  }
  return DateTimeComponentsFormatClass;
}
var TwoDigitNumberClass;
function TwoDigitNumber() {
  if (TwoDigitNumberClass === VOID) {
    class $ {
      constructor(reference) {
        this.w1t_1 = reference;
      }
    }
    initMetadataForClass($, 'TwoDigitNumber');
    TwoDigitNumberClass = $;
  }
  return TwoDigitNumberClass;
}
function DateTimeComponentsContents$_get_timeZoneId_$ref_e986wv_0() {
  return (p0) => p0.j1p_1;
}
function DateTimeComponentsContents$_set_timeZoneId_$ref_b9v94l_0() {
  return (p0, p1) => {
    p0.j1p_1 = p1;
    return Unit_instance;
  };
}
var properties_initialized_DateTimeComponents_kt_io5e5;
function _init_properties_DateTimeComponents_kt__9iimb5() {
  if (!properties_initialized_DateTimeComponents_kt_io5e5) {
    properties_initialized_DateTimeComponents_kt_io5e5 = true;
    var tmp = KMutableProperty1();
    var tmp_0 = DateTimeComponentsContents$_get_timeZoneId_$ref_e986wv_0();
    timeZoneField = new (GenericFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('timeZoneId', 1, tmp, tmp_0, DateTimeComponentsContents$_set_timeZoneId_$ref_b9v94l_0())));
    emptyDateTimeComponentsContents = new (DateTimeComponentsContents())();
  }
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Formats_getInstance as Formats_getInstance1ivgshh4uvub1,
};
//endregion

//# sourceMappingURL=DateTimeComponents.mjs.map
